interface WhyUsProps {
  onQuoteClick: () => void;
}

const reasons = [
  {
    icon: 'ri-building-4-line',
    title: 'Construction-Focused Expertise',
    description: 'We specialize exclusively in construction and commercial cleaning — not general housekeeping. We understand job sites, build phases, and contractor timelines.',
  },
  {
    icon: 'ri-time-line',
    title: 'Reliable & On Schedule',
    description: 'We show up when we say we will. Our scheduling is built around your construction timeline so cleaning never delays your project handoff.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Detail-Oriented Results',
    description: 'We don\'t cut corners. Every surface, fixture, and floor is cleaned to a standard that passes final inspections and impresses property owners.',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'Local Las Vegas Service',
    description: 'We\'re based in Las Vegas and serve the local construction community. Fast response, local knowledge, and commitment to the community we work in.',
  },
  {
    icon: 'ri-team-line',
    title: 'Professional Cleaning Crew',
    description: 'Our team is trained, equipped, and experienced in post-construction environments — working safely and efficiently on active and completed job sites.',
  },
  {
    icon: 'ri-shake-hands-line',
    title: 'Trusted by Contractors',
    description: 'General contractors, builders, and developers across Las Vegas rely on us for consistent, high-quality cleaning that reflects well on their finished projects.',
  },
];

export default function WhyUs({ onQuoteClick }: WhyUsProps) {
  return (
    <section id="why-us" className="bg-[#1a1a1a] py-24 px-6 md:px-16 lg:px-24">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Left */}
        <div>
          <div className="inline-flex items-center gap-2 mb-6">
            <div className="w-8 h-px bg-[#C9A84C]"></div>
            <span className="font-inter text-[#C9A84C] text-xs tracking-widest uppercase">Why Choose Us</span>
          </div>
          <h2 className="font-barlow-condensed font-900 text-white text-4xl md:text-5xl lg:text-6xl leading-none mb-8">
            THE STANDARD<br />CONTRACTORS<br /><span className="text-[#C9A84C]">RELY ON</span>
          </h2>
          <p className="font-inter text-white/60 text-sm leading-relaxed mb-10 max-w-md">
            When your project is done, the cleaning shouldn\'t be an afterthought. Quiroz Construction Cleaning delivers the professional-grade results that make your work look its best.
          </p>
          <button
            onClick={onQuoteClick}
            className="inline-flex items-center gap-3 bg-[#C9A84C] hover:bg-[#E8C96A] text-[#1a1a1a] font-barlow font-800 text-sm px-8 py-4 rounded-sm transition-all duration-200 cursor-pointer whitespace-nowrap tracking-widest uppercase"
          >
            Get a Quote
            <i className="ri-arrow-right-line"></i>
          </button>

          {/* Image */}
          <div className="mt-12 rounded-sm overflow-hidden h-64">
            <img
              src="https://public.readdy.ai/ai/img_res/eed4fcc8a138840acabe926af071c0cd.jpg"
              alt="Quiroz Construction Cleaning professional team Las Vegas"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Right - reasons grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {reasons.map((reason) => (
            <div
              key={reason.title}
              className="bg-white/5 border border-white/10 rounded-sm p-6 hover:border-[#C9A84C]/40 hover:bg-white/8 transition-all duration-300 cursor-default"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-[#C9A84C]/15 rounded-sm mb-4">
                <i className={`${reason.icon} text-[#C9A84C] text-lg`}></i>
              </div>
              <h3 className="font-barlow font-700 text-white text-sm tracking-wide mb-2">{reason.title}</h3>
              <p className="font-inter text-white/50 text-xs leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
